@defer (on immediate) {
<section resource-hero [slides]="heroSlides"></section>
} @placeholder {
<section class="vw-100 vh-100"></section>
}

<section
  jump-to
  [borders]="false"
  [mobileWrap]="true"
  [reorderMobile]="false"
  [wrapIndex]="2"
  [jumpToData]="jumpToData"
  [activeSection]="jumpToData[0].buttonFragment"
></section>
<section information></section>
<!-- <section why-early></section> -->

<!-- <section metabolic></section> -->
<!-- <section beta-cell></section> -->

<section real-voices></section>
<section how-to-explain></section>
<!-- <section family-factor></section> -->
<section hcp-resources></section>
<section patient-resources></section>
<section aditional-resources></section>
<section
  cta-bottom
  class="useful-tools mx-auto"
  [data]="ctaBottomData"
></section>
<section references ngSkipHydration></section>
<review-bar dateText="in August 2026"></review-bar>
